import React from 'react'
import { Text } from 'hocs/localization'
import Modal, { ModalMessage, ModalFooter, ModalFooterButtons } from 'apps/Modal'
import Button from 'elements/Button'
import { toCurrency } from 'utils/price'
import * as styles from './ConfirmCancelSubscriptionModal.scss'
import { Select, Textarea } from 'shared/apps/FormFields'
import { MAX_LENGTHS } from 'constants/forms'
import { Field } from 'redux-form'
import { API_TYPES } from 'constants/apiTypes'

interface IProps {
  t: Text,
  name: string,
  onClose: () => void,
  onCancelSubscription: () => void,
  handleSubmit: () => void,
  isWithFee: boolean,
  fee: number,
  isSubmitting: boolean,
  otherSelected: boolean,
  reasonOptions: any[],
  setOtherSelected: any,
  setValid: any,
  valid: boolean  
}

interface IState {  
  otherSelected: boolean,
  valid: boolean,
  details: string
}

export const OTHER_REASON_ID = 5
export const MIN_REASON_LENGTH = 3

class ConfirmCancelSubscriptionModal extends React.Component<IProps, IState> {
  
  public onChangeReason = (event, newValue) => {

    if (newValue == null)
    {
      this.props.setValid(false)
      return;
    }

    if (newValue === OTHER_REASON_ID)
    {
        this.props.setOtherSelected(true)
        this.props.setValid(this.state != null && this.state.details.length >= MIN_REASON_LENGTH)
        return;
    }
    else 
    {
      this.props.setValid(true)
      this.props.setOtherSelected(false) 
    }
  }

  public onChangeDetails = (event, newValue) => {
      this.props.setValid(newValue.length >= MIN_REASON_LENGTH)
      this.setState({ details: newValue });
  }

public render()
{ 

  const {
    name,
    onClose,
    onCancelSubscription,
    handleSubmit,
    onSubmit,
    isSubmitting,
    valid,
    otherSelected,
    fee,
    isWithFee,
    t,
    reasonOptions
    } = this.props

  const caution = `${t('caution')} ${isWithFee ? t('feeInformation', { fee: toCurrency(fee) }) : ''}`

  return (   
    
    <Modal name={name} shouldCloseOnOverlayClick={!isSubmitting}>
       <form className={styles.root} onSubmit={handleSubmit(onSubmit)}>
      <ModalMessage>
        {t('chooseReason')}       
        <div className={styles.fieldWrapper}>
        <Field
          name="CancellationReasonId"
          component={Select}
          placeholder={t('reasonPlaceholder')}
          disabled={isSubmitting}
          options={[...reasonOptions]}
          label={t('reasonLabel')}
          onChange={this.onChangeReason}
          apiTypes={[API_TYPES.cancelationReasons]}
          required          
        />
      </div>
      <div className={otherSelected ? styles.fieldWrapper : styles.hiddenField}>
          <Field
            name="CancellationReasonDetails"
            component={Textarea}
            maxLength={MAX_LENGTHS.cancellationReason}
            rows={3}
            placeholder={t('reasonPlaceholder')}
            onChange={this.onChangeDetails}
            disabled={isSubmitting}
            label={t('cancellationReasonDetails')}
            required={otherSelected}
            value={otherSelected}
          />
      </div>
      <div className={styles.cautionBlock}>{caution}</div>
      <div>{t('question')}</div>      
      </ModalMessage>
      <ModalFooter>
        <ModalFooterButtons>
          <div className={styles.buttonWrapper}>
            <Button fluid disabled={!valid || isSubmitting}>
              {isSubmitting ? t('yesSubmitting') : t('yes')}
            </Button>
          </div>
          <Button onClick={onClose} styleType='red' disabled={isSubmitting}>
            {t('no')}
          </Button>
        </ModalFooterButtons>
      </ModalFooter>
      </form>
    </Modal>
  )
}
}

export default ConfirmCancelSubscriptionModal
